<template>
	<div class="template file" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap upfile-file-part">
			<div class="file-wrap-title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</div>
			<!-- <label class="panel_title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </label> -->
			<div class="panel_content">
				<div class="upload-file">
					<input multiple="multiple" type="file" @change="getFile($event)" class="upload-button" />
				</div>
				<div style="color: red;">附件提示：当前仅支持最多6个附件（包含压缩包）上传，单个附件大小不超过20M，注意在线预览不支持rar格式的打包文件，建议用zip格式打包上传。</div>
				<!-- <div v-for="item in dataVal.fileNames" :key="item.key" style="line-height: 28px;color: #4d4e50;">{{item.key}}&nbsp;<span
					 @click="deleteFile(item.val)" style="display: inline-block;padding-left: 6px;color: #f94c4c;font-size: 13px;">删除</span></div> -->


				<div class="file-list" v-show="dataVal.fileNames && dataVal.fileNames.length > 0">
					<div class="file-item clearfix" v-for="item in dataVal.fileNames" :key="item.val" @click="getFileInfo(item.val)">
						<div class="file-type" :class="item.key.substring(item.key.lastIndexOf('.')+1) == 'png'?'img'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'jpg'?'img'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'jpeg'?'img'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'gif'?'img'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'doc'?'word'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'docx'?'word'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'xls'?'execl'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'xlsx'?'execl'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'ppt'?'ppt'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'pptx'?'ppt'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'txt'?'txt'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'html'?'html'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'zip'?'zip'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'pdf'?'pdf'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'amr'?'voice'
						:item.key.substring(item.key.lastIndexOf('.')+1) == 'mp4'?'video':'file'"></div>
						<div class="file-info">
							<div class="file-neme">{{item.key}}</div>
							<div class="file-time">{{item.time | transformTime}}</div>
						</div>
						<div class="del" @click.stop="deleteFile(item.val)"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		uploadFile,
		getFileInfoByMediaId
	} from '@/api/file'
	import wx from 'weixin-js-sdk'
	export default {
		props: ['dataVal'],
		data() {
			return {
				isPhone:null,
				isWxwork:null
			}
		},
		mounted() {
			this.browserRedirect()
		},
		methods: {
			browserRedirect() {
				var sUserAgent = window.navigator.userAgent.toLowerCase();
				if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
					this.isPhone = true;
				}
				if(sUserAgent.match(/wxwork/i) == 'wxwork'){
					this.isWxwork = true;
				}
			},
			getFile(event) {
				let that = this;
				if (that.dataVal.Values == null) {
					that.dataVal.Values = [];
				}
				if (that.dataVal.Values.length >= 6) {
					that.$message.info('附件上传提示：当前仅支持最多6个附件上传，超过6个请用zip格式打包上传。注意在线预览不支持rar格式的打包文件。');
					return;
				}
				// 上传文件
				let file = event.target.files
				if (file == null || file.length == 0) {
					that.$message.info('取消上传文件...');
					return;
				}
				that.$message.info('文件上传中...');
				let formData = new FormData()
				formData.append('category', 'settingPic')
				if((that.dataVal.Values.length+file.length)>6){
					that.$message.info('附件上传提示：当前仅支持最多6个附件上传，超过6个请用zip格式打包上传。注意在线预览不支持rar格式的打包文件。');
					return;
				}
				for (var j = 0; j < file.length; j++) {
					if ((file[j].size / 1024 / 1024) > 20) {
						that.$message.info('文件大小不能超过20M!');
						return;
					}
					formData.append('file', file[j]);
				}
				var strs = event.currentTarget.value.split("\\");
				uploadFile(formData).then((res) => {
					that.$message.info('上传成功!');
					if (that.dataVal.fileNames && that.dataVal.fileNames != 0) {
						var fileNames = that.dataVal.fileNames;
					} else {
						var fileNames = []
					}
					for (var i = 0; i < res.Body.length; i++) {
						fileNames.push({
							"key": res.Body[i].fileName,
							"val": res.Body[i].MediaId,
							"time": res.Body[i].CreatedAt,
							'type': res.Body[i].type
						});
						that.dataVal.Values.push([res.Body[i].MediaId]);
					}
					this.$set(that.dataVal, 'fileNames', fileNames);

				});
			},
			deleteFile(val) {
				var fileNames = this.dataVal.fileNames;
				var Values = this.dataVal.Values;
				for (var i = 0; i < fileNames.length; i++) {
					if (fileNames[i].val == val) {
						fileNames.splice(i, 1);
						break;
					}
				}
				for (var j = 0; j < Values.length; j++) {
					if (Values[i][0] == val) {
						Values.splice(i, 1);
						break;
					}
				}
			},
			previewBtn(data) {
				// let timestamp = Date.parse(new Date());
				// this.addCookie('access_token',timestamp,0);
				window.open(data.Url, '_blank');
				/* wx.previewFile({
						url: data.Url+'?access_token='+data.AccessToken, // 需要预览文件的地址(必填，可以使用相对路径)
						name: data.FileName, // 需要预览文件的文件名(不填的话取url的最后部分) 
						size: data.FileSize // 需要预览文件的字节大小(必填)
					}
				); */
			},
			getFileInfo(id) {
				// if(!this.isPhone || !this.isWxwork){
				// 	this.$message.warning("预览文件仅在企业微信APP手机端可用")
				// 	return;
				// }
				getFileInfoByMediaId(id).then(res => {
					if (res.ErrCode !== 0) {
						this.$message.error(res.ErrMsg);
						return;
					}
					this.previewBtn(res.Body);
				}).catch(err => {
				})
			},
			addCookie(objName, objValue, objHours) {
			    var str = objName + "=" + escape(objValue); //编码
			    if (objHours > 0) {//为0时不设定过期时间，浏览器关闭时cookie自动消失
			        var date = new Date();
			        var ms = objHours * 3600 * 1000;
			        date.setTime(date.getTime() + ms);
			        str += "; expires=" + date.toGMTString();
			    }
			    document.cookie = str;
			},
			getCookie(objName) {//获取指定名称的cookie的值
			    var arrStr = document.cookie.split("; ");
			    for (var i = 0; i < arrStr.length; i++) {
			        var temp = arrStr[i].split("=");
			        if (temp[0] == objName) return unescape(temp[1]);  //解码
			    }
			    return "";
			}
			
		},
		filters: {
			transformTime(val) {
				if (val) {
					val = parseInt(val) * 1000;
					var time = new Date(val);
					var y = time.getFullYear();
					var m = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
					var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
					var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
					var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
					var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
					return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
				}
			},
			getFileType(val) {
				if (val) {
					return val.substring(val.lastIndexOf(".") + 1)
				}
			}
		}
	}
</script>

<style lang="less">
	@import '../assets/css/common.css';

	.file-list {
		margin-top: 10px;

		.file-item {
			width: 100%;
			margin-bottom: 10px;
			box-shadow: 6px 6px 6px #ccc;
			padding: 6px;
			border-radius: 2px;
			position: relative;

			.file-type {
				width: 58px;
				height: 48px;
				float: left;
				background: url(../assets/image/img.png) no-repeat;
			}

			.txt {
				height: 48px;
				width: 48px;
				background-position: 0 0;
			}

			.zip {
				height: 48px;
				width: 48px;
				background-position: -55px 0;
			}

			.word {
				height: 48px;
				width: 48px;
				background-position: -112px 0;
			}

			.voice {
				height: 48px;
				width: 48px;
				background-position: -169px 0;
			}

			.pdf {
				height: 48px;
				width: 48px;
				background-position: -224px -1px;
			}

			.execl {
				height: 48px;
				width: 48px;
				background-position: -278px 0;
			}

			.file {
				height: 48px;
				width: 48px;
				background-position: -335px 0;
			}

			.img {
				height: 48px;
				width: 48px;
				background-position: -390px 0;
			}

			.html {
				height: 48px;
				width: 48px;
				background-position: -446px 0;
			}

			.ppt {
				height: 48px;
				width: 50px;
				background-position: -500px 0;
			}

			.video {
				height: 48px;
				width: 58px;
				background-position: -556px 0;
			}


			.file-info {
				float: left;
				width: calc(100% - 58px);
				padding-left: 4px;
				position: relative;

				.file-neme {
					font-size: 13px;
					padding-top: 6px;
					color: #232323;
					width: 100%;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.file-time {
					font-size: 12px;
					padding-top: 2px;
				}
			}

			.del {
				position: absolute;
				width: 26px;
				height: 26px;
				background: url(../assets/image/icons.png) no-repeat;
				background-position: -633px 0;
				top: 0;
				right: 0;
			}
		}
	}

	.clearfix:after,
	.clearfix:before {
		content: "";
		display: block;
		clear: both;
	}
</style>
